import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { fetchCmsPageBySlug } from '../lib/cms';
import ContactFormSection from '../components/ContactFormSection';

export default function GenericPage() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      setLoading(true);
      const data = await fetchCmsPageBySlug(slug);
      setPageData(data);
      setLoading(false);
    }
    loadPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <div className="flex items-center gap-3 text-sky-800 font-bold">
          <i className="fa-solid fa-spinner animate-spin text-xl" aria-hidden="true" />
          <span>Henter side...</span>
        </div>
      </div>
    );
  }

  const title = pageData?.title || slug;
  const metaTitle = pageData?.meta_title || `${title} · OP RENGØRINGSSERVICE`;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={pageData?.meta_description || metaTitle} />
        <meta property="og:title" content={metaTitle} />
        <link rel="canonical" href={`https://opservice.dk/${slug}`} />
      </Helmet>

      <section className="bg-slate-900 text-white py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-3xl">
          <span className="text-xs font-bold text-emerald-400 uppercase tracking-widest bg-emerald-500/10 px-3 py-1 rounded-full border border-emerald-500/20 inline-block mb-3">
            OP RENGØRINGSSERVICE
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mb-4">
            {title}
          </h1>
          {pageData?.intro && (
            <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
              {pageData.intro}
            </p>
          )}
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose-custom">
            {pageData?.body_text ? (
              <div dangerouslySetInnerHTML={{ __html: pageData.body_text }} />
            ) : (
              <p className="text-slate-600">Ingen tekst tilgængelig.</p>
            )}
          </div>

          <div className="mt-12 pt-8 border-t border-slate-200 flex items-center justify-between">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sky-800 font-bold hover:text-sky-900 text-sm"
            >
              <i className="fa-solid fa-arrow-left" aria-hidden="true" />
              <span>Gå til forside</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-sky-800 text-white font-bold py-2.5 px-4 rounded-lg text-sm hover:bg-sky-900 transition-colors"
            >
              <span>Kontakt os</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      <ContactFormSection />
    </>
  );
}
